import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { TranslateService } from '@ngx-translate/core';

// Import default language translations for immediate availability
import defaultTranslations from '../../public/assets/i18n/en.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private translateService = inject(TranslateService);
  protected readonly title = signal('admin');

  constructor() {
    // Set the static translations for immediate availability
    this.translateService.setTranslation('en', defaultTranslations);

    // Set the default language - translations are already available
    this.translateService.setFallbackLang('en');
    this.translateService.use('en');
  }
}
